import React from 'react';
import { Action, PageBody, PageHead } from '../../components/aa';
import VendorEvaluatorPage from '../aai/VendorEvaluatorPage';
import { useRegistryEyebrow } from './RegistryPanel';

/*
 * Vendor evaluations for the champion, reached from the Use Case Registry.
 * The evaluator itself is the existing page, shown alone rather than inside
 * the old hub that put the old registry tab beside it.
 */

const ChampionVendorsPage: React.FC = () => (
  <PageBody>
    <PageHead
      align="center"
      eyebrow={useRegistryEyebrow()}
      title="Vendor evaluations"
      sub="Which tool should the company use, and why. Each evaluation compares vendors on fit, cost, data handling and risk."
      actions={<Action variant="quiet" to="/registry">Back to registry</Action>}
    />
    <VendorEvaluatorPage />
  </PageBody>
);

export default ChampionVendorsPage;
